import styled from 'styled-components'

export const TravelRuleTableWrapper = styled.div``
